import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import heroImage from "@/assets/hero-native-garden-wildlife.jpg";

const NewHeroSection = () => {
  return (
    <section className="relative overflow-hidden bg-hero-pattern">
      <div className="container relative z-10 py-6 md:py-16 lg:py-20">
        <div className="grid lg:grid-cols-2 gap-6 lg:gap-12 items-center">
          <div className="order-1 max-w-xl space-y-3 sm:space-y-4">
            <h1 className="font-display text-[1.65rem] leading-[1.25] sm:text-4xl md:text-5xl lg:text-[3.25rem] font-bold sm:leading-[1.2] text-balance">
              Create a Beautiful Yard That Supports Butterflies, Birds, and Pollinators — Without Guesswork
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-foreground/90 leading-relaxed max-w-lg">
              Regionally validated native planting plans built for your exact location, sunlight, soil, and ecosystem.
            </p>
            <div className="flex flex-wrap items-center gap-2 text-sm">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary/10 text-primary font-semibold">
                Plans start at $7
              </span>
              <span className="text-xs text-muted-foreground">Quick $7 · Full $15 · Hopper's Guide $29/mo</span>
            </div>
            <div className="pt-1 w-full max-w-md">
              <Link to="/create" className="block w-full" aria-label="Start my native plant plan">
                <Button variant="hero" size="xl" className="w-full min-h-[52px]">
                  Start My Plan
                  <ArrowRight className="ml-2 h-5 w-5" aria-hidden="true" />
                </Button>
              </Link>
            </div>
            <p className="text-xs text-muted-foreground pt-1 pb-1">
              Takes less than 60 seconds. No experience needed.
            </p>
            <p className="text-xs pb-2">
              <Link to="/examples" className="text-muted-foreground underline underline-offset-4 hover:text-primary transition-colors" aria-label="See an example plan">
                or see an example plan
              </Link>
            </p>
          </div>

          <div className="order-2">
            <div className="rounded-2xl overflow-hidden shadow-xl border border-border/30">
              <img
                src={heroImage}
                alt="Lush native pollinator garden with coneflowers and a monarch butterfly in a residential front yard"
                className="w-full aspect-[16/10] object-cover"
                width={800}
                height={500}
                loading="eager"
                fetchPriority="high"
                decoding="sync"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewHeroSection;
